import React from "react"

import GymListPage from "@/gym/pages/GymListPage"

export default () => <>
  <GymListPage />
</>
